"use client";

import { useEffect } from "react";
import { registerIdealitikaWebMcpTools } from "@/lib/webmcp/register-imperative-tools";

/**
 * Регистрирует imperative WebMCP tools через document.modelContext.
 * Без поддержки браузера — no-op.
 */
export function WebmcpImperativeTools() {
  useEffect(() => {
    const controller = new AbortController();
    void registerIdealitikaWebMcpTools(controller.signal);
    return () => controller.abort();
  }, []);

  return null;
}
